import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import StudentSurvey from "../components/StudentSurvey";
import {
  updateUserPreference,
  getPreferenceData,
} from "../helper/apicalls/survey";
import { updateUserCoins, updateUserXP } from "../helper/authUtils";
import "../styles/SurveyPage.scss";

const SurveyPage = () => {
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);

  const handleComplete = async (answers) => {
    const sourceQuestions =
      Array.isArray(questions) && questions.length > 0 ? questions : [];

    const preference = sourceQuestions
      .map((q) => {
        const key = q.sequence ?? q.id;
        const value = answers?.[key];
        if (
          value === undefined ||
          value === null ||
          String(value).trim() === ""
        ) {
          return null;
        }
        return {
          question: q.question,
          answer: String(value).trim(),
        };
      })
      .filter(Boolean);

    const payload = {
      preference,
    };

    try {
      const res = await updateUserPreference(payload);
      if (res && res.page_completion_coins) {
        await updateUserCoins();
      }
      if (res && res.page_completion_xp) {
        updateUserXP(res.page_completion_xp);
      }

      const updateStorage = () => {
        const storedUser = Cookies.get("user");
        if (storedUser) {
          try {
            const parsed = JSON.parse(storedUser);
            parsed.preference = true;
            Cookies.set("user", JSON.stringify(parsed));
            return parsed;
          } catch (e) {
            console.error("Error updating user preference in storage:", e);
          }
        }
        return null;
      };

      const sessionUser = updateStorage();
      const user = sessionUser;

      if (user) {
        const testCount = user.test_count;
        const iqTestCompleted = user.iqTest_completed;
        const psychometricTestCompleted = user.psychometricTest_completed;

        if (!testCount || testCount === 0) {
          navigate("/test");
          return;
        }

        if (testCount === 1) {
        if (iqTestCompleted || psychometricTestCompleted) {
          navigate("/dashboard");
        } else {
          navigate("/test");
        }
          return;
        }

        if (testCount === 2) {
          if (iqTestCompleted && psychometricTestCompleted) {
            navigate("/dashboard");
          } else {
            navigate("/test");
          }
          return;
        }

        navigate("/dashboard");
      }
    } catch (error) {
      console.error("Failed to update user preference:", error);
    }
  };

  const getPreferencedata = async () => {
    try {
      const res = await getPreferenceData();
      const apiQuestions =
        Array.isArray(res?.data) || Array.isArray(res?.content)
          ? res.data || res.content
          : Array.isArray(res)
          ? res
          : [];

      if (apiQuestions.length > 0) {
        setQuestions(apiQuestions);
      } else {
        setQuestions([]);
      }
    } catch (error) {
      console.error(error);
      setQuestions([]);
    }
  };

  useEffect(() => {
    getPreferencedata();
  }, []);

  useEffect(() => {
    const storedUserRaw = Cookies.get("user");

    if (storedUserRaw) {
      try {
        const parsedUser = JSON.parse(storedUserRaw);
        const preference = parsedUser?.preference;
        const test = parsedUser?.test;
        const bothTrue = preference === true && test === true;
        if (bothTrue) {
          navigate("/dashboard");
        }
      } catch (e) {}
    }
  }, [navigate]);

  return (
    <div className="survey-page-container">
      <div className="survey-body">
        <div className="survey-question-wrapper">
          <div className="survey-title">Preferences</div>
          <StudentSurvey
            questions={
              Array.isArray(questions) && questions.length > 0 ? questions : []
            }
            onComplete={handleComplete}
          />
        </div>
      </div>
    </div>
  );
};

export default SurveyPage;
